var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isDocumentLoad && !_vm.isDocumenViewMode)?_c('div',[_c('ejs-filemanager',{directives:[{name:"viewer",rawName:"v-viewer"}],attrs:{"id":"file-manager","ajaxSettings":_vm.ajaxSettings,"height":_vm.richtextHeight}})],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66e9591d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/S070000-Employee/S070200-EmployeeProfile/S070200-EmployeeDocument.vue
// module id = null
// module chunks = 